import React from 'react';
import ReactSelect from 'react-select';
import { translate } from '../Services/translation';
import Icon from './IconBase/Icon';

export const StyledSelectComponents = {
  DownChevron: <Icon iconCode="expand_more" />,
  IndicatorSeparator: null,
};

export const StyledSelectStyles = {
  control: (provided) => ({
    ...provided,
    height: 48,
  }),
};

const StyledSelect = (props) => {
  return (
    <ReactSelect
      placeholder={translate('general.select-placeholder')}
      {...props}
      styles={{ ...StyledSelectStyles, ...props.styles }}
      components={{ ...StyledSelectComponents, ...props.components }}
    />
  );
};

export default StyledSelect;
